<section class="left">
  <div class="logo-section">
    <img src="/assets/images/logo.png" alt="Logo" />
    <div class="brand">{{ brand.name }}</div>
  </div>

  <div class="form">
    <h3 class="prompt">{{ 'Accept invitation' }}</h3>
    <div class="form-group">
      <input
        [(ngModel)]="password"
        [type]="passwordRevealed ? 'text' : 'password'"
        id="password"
        name="password"
        placeholder="{{ 'Create a password' }}"
      />
      <button mat-icon-button class="reveal" (click)="passwordRevealed = !passwordRevealed">
        <i class="icon-eye"></i>
      </button>
    </div>
    <div class="form-group">
      <input
        [(ngModel)]="confirmPassword"
        [type]="passwordRevealed ? 'text' : 'password'"
        id="password"
        name="password"
        (keyup.enter)="acceptInvite()"
        placeholder="{{ 'Confirm password' }}"
      />
      <button mat-icon-button class="reveal" (click)="passwordRevealed = !passwordRevealed">
        <i class="icon-eye"></i>
      </button>
    </div>
    <button mat-flat-button color="primary" (click)="acceptInvite()" [appLoading]="isLoading">
      {{ 'Accept invitation' }}
    </button>

    <app-error [error]="error"></app-error>
  </div>

  <div class="links"></div>
</section>

<section class="right">
  <img src="/assets/images/login.svg" />
</section>
